// Vuex
import store from "@/store/index.js";

function checkExistsInfoUser() {
	let userInfo = store.state.user.user;

	if (!userInfo) {

		window.axios.defaults.headers.common['Authorization'] = 'Bearer ' + window.sessionStorage.getItem('sre_young_token');
		return axios.get("/api/user")
			.then((response) => {
				if(response && response.data && response.data.user){
					store.commit("setUser", response.data.user);
				}

				return true;

			}).catch((error) => {
				console.log("error:", error);
				return Promise.reject(error);
			});

	} else {
		return true;
	}

};

function checkProfile(...permission) {
	let check = false;
	const profile = store.state.user && store.state.user.user ? store.state.user.user.cat_profile_id : null;
	permission.forEach((item) => {
		if (profile == item) {
			return check = true;
		}
	});
	return check;
}
function checkExistHaveARelationshipWithCompany(){
	let check = false;
	const training_count = store.state.user && store.state.user.user && store.state.user.user.people ? parseInt(store.state.user.user.people.people_advisor_training_count) : 0;
	if(training_count>0){
		check = true;
	}
	return check;
}
export default {
	checkExistsInfoUser,
	checkProfile,
	checkExistHaveARelationshipWithCompany

};